import { Store } from 'redux';
import { ReduxStore } from '~/App/shared/interfaces/store';
import configureStore from '~/helpers/client/configureStore';

const store: Store<ReduxStore> = configureStore();

export default store;
